<template>
  <div class="d-flex justify-content-between align-items-center w-100 ml-2">
    <div class="" v-if="isLoading"><b-skeleton width="30px" height="24px"></b-skeleton></div>
    <div v-else>
      <i class="fa-chevron-left fas icon-xl mr-2 navigationIcons" @click="$emit('go-up')"></i>
      <i class="fa-chevron-right fas icon-xl mr-2 navigationIcons" @click="$emit('go-down')"></i>
    </div>
    <div v-if="isLoading || !activeReisetermin">
      <b-skeleton width="164px" height="24px"></b-skeleton>
    </div>
    <div v-else style="display: flex; justify-content: center; flex-direction: column">
      <a :href="'#/reisetermine/' + activeReisetermin.id" target="_blank">
        <h4 class="mb-0">
          <b>{{ reiseterminkuerzelFormatted }}</b>
        </h4>
      </a>

      <span style="font-size: 1rem" v-if="activeReisetermin?.ursprungsreiseterminId">
        Ehemals:
        <a target="blank" :href="'/#/reisetermine/' + activeReisetermin.ursprungsreiseterminId">
          {{ activeReisetermin.ursprungsreisetermin?.reiseterminkuerzel }}
        </a>
      </span>
      <span style="font-size: 1rem" v-if="activeReisetermin?.ersatztermin">
        Ersatztermin:
        <a target="blank" :href="'/#/reisetermine/' + activeReisetermin.ersatztermin.id">
          {{ activeReisetermin.ersatztermin?.reiseterminkuerzel }}
        </a>
      </span>
    </div>
    <div v-if="isLoading || !activeReisetermin"><b-skeleton></b-skeleton></div>
    <div v-else>
      <b-button
        class="btn btn-icon ml-auto mr-2 icon-button"
        size="sm"
        title="Reisestammdaten"
        :href="
          '#/reisen/' +
          activeReisetermin.reiseterminkuerzel?.substring(0, 6) +
          '/reisestammdaten?reiseterminAbreisedatum=' +
          activeReisetermin.abreisedatum.substring(0, 10)
        "
        target="_blank"
      >
        <i class="flaticon-edit" />
      </b-button>
      <b-dropdown right text="..." no-caret size="sm" class="mr-3" toggle-class="dialog-btn-secondary">
        <template #button-content>
          <div class="dots-dropdown">...</div>
        </template>
        <b-dropdown-item
          v-if="activeReisetermin?.state !== 'Aufgelegt'"
          size="sm"
          @click="$emit('status-bearbeiten')"
        >
          Status bearbeiten
        </b-dropdown-item>
        <b-dropdown-item size="sm" @click="$emit('aufgabe-erstellen')" v-b-modal.modalAufgabeEdit>
          Aufgabe erstellen
        </b-dropdown-item>
        <b-dropdown-item
          v-if="activeReisetermin?.ersatztermin == null"
          size="sm"
          @click="$emit('termin-verschieben')"
        >
          Termin verschieben
        </b-dropdown-item>
        <b-dropdown-item
          size="sm"
          @click="$emit('reisetermin-loeschen')"
          variant="danger"
          v-if="activeReisetermin?.reiseterminSyncState === 'NotAvailableInBlank'"
        >
          Reisetermin löschen
        </b-dropdown-item>
      </b-dropdown>
      <b-button
        class="dialog-btn mr-4"
        size="sm"
        @click="$emit('save')"
        :variant="disableSpeichernButton ? 'secondary' : 'primary'"
        :disabled="disableSpeichernButton"
      >
        Speichern
      </b-button>
      <i class="fas fa-times m-3 navigationIcons" @click="$emit('close')"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarTerminplanungHeader',
  props: {
    isLoading: { type: Boolean, default: false },
    activeReisetermin: { type: Object, default: null },
    reiseterminkuerzelFormatted: { type: String, default: '' },
    disableSpeichernButton: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.btn.btn-icon.icon-button {
  width: 32px;
  height: 32px;
}

.navigationIcons {
  color: black;
}

.navigationIcons:hover {
  color: #0d6efd;
  cursor: pointer;
}
</style>
